var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrowelBricks = function SvgTrowelBricks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 37 37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#trowelBricks_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.081c0-.78-.4-1.505-1.069-1.913a2.24 2.24 0 0 0-2.187-.098l-13.5 6.75A2.24 2.24 0 0 0 .5 9.83c0 .852.478 1.632 1.245 2.012l13.5 6.75a2.251 2.251 0 0 0 3.255-2.01v-5.064h6.258a2.255 2.255 0 0 0 2.18 1.688h6.187a3.376 3.376 0 0 0 0-6.75h-6.187a2.255 2.255 0 0 0-2.18 1.687H18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16.58h11.25a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25H23a2.25 2.25 0 0 1-2.25-2.25v-4.5A2.25 2.25 0 0 1 23 16.58M.5 30.08a2.25 2.25 0 0 1 2.25-2.25H9.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25H2.75A2.25 2.25 0 0 1 .5 34.58zm13.5 0a2.25 2.25 0 0 1 2.25-2.25h18a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-18A2.25 2.25 0 0 1 14 34.58z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trowelBricks_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5.83h36v36H.5z"
  })))));
};
export default SvgTrowelBricks;